import React from 'react';
import AutoComplete from '../../../components/form/AutoComplete'

const OvmAutoComplete = (props) => (
  <AutoComplete dataSourceConfig={{value: 'id', text: 'subject'}} noActiveFilter {...props} />
);

export default OvmAutoComplete;